import React, { useCallback, useState, useMemo } from 'react'
import TextInput, { TextInputs } from './components/atoms/TextInput'
import { getItemFile } from './utils/items'
import Canvas from './components/molecules/Canvas'
import './App.css'

function App() {
  const [textName, setTextName] = useState<string>('')
  const [inputName, setInputName] = useState<string>('')
  const [textMenu, setTextMenu] = useState<string>('')
  const [inputMenu, setInputMenu] = useState<Array<string>>([])
  const [divWidth, setDivWidth] = useState<number>(680)
  const [frameImage, setFrameImage] = useState<string>('item11')

  const getDivStatus = useCallback((node: any) => {
    if (node !== null) {
      setDivWidth(node.getBoundingClientRect().width)
    }
  }, [])

  useMemo(() => {
    let random = Math.floor(Math.random() * 11) + 1
    let name = 'item' + ('00' + random).slice(-2)
    setFrameImage(name)
  }, [])

  const handleChangeName = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setTextName(event.target.value)
  }
  const handleChangeMenu = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setTextMenu(event.target.value)
  }

  const handleSubmit = (): void => {
    setInputName(textName)
    const arr = textMenu.split('\n')
    setInputMenu(arr)
  }

  return (
    <div className="flex justify-center w-full h-full bg-primary">
      <div className="py-2 w-full font-xl text-right font-famicon text-black ">
        <div className="px-4 py-4 my-4 text-sm rounded-md text-left font-sans ">
          <p className="my-2 font-bold text-lg">
            これであなたも武将!? 敵陣撃退のための筋トレ成果を報告しよう！
          </p>
          <p className="my-2 font-semibold">
            【筋トレ日次報告書画像】はSNS上にシェアいただいてOKです！
          </p>
          <p className="ml-6">
            再配布を目的としたネットワークへのアップロード、目的外での利用はNGとなります。
          </p>
          <p className="my-2 font-semibold">【使い方】</p>
          <ul className="list-disc ml-6">
            <li>
              入力フォームに行った筋トレメニューと回数を入力し、ボタンを押すと、画像に入力した文字が反映されます。
            </li>
            <li>
              1メニューごとに改行ください。合計4メニューまで記入できます（文字数は1メニュー16文字まで）。
            </li>
            <li>
              文字は何度でも修正・変更が可能ですが、日付・時刻は最新時点の情報が反映されます。
            </li>
            <li>
              文字が反映されない場合や画像が白くなった場合は、一度別の文字を入力の上ボタンを押し、再度修正ください。
            </li>
          </ul>
        </div>
        <div className="max-w-[680px] px-4 py-0">
          <div className="py-3 flex justify-end bg-god-pattern bg-opacity-10 bg-no-repeat bg-right">
            <div className="w-full sm:w-3/4 text-right">
              <TextInput
                type={TextInputs.INPUT}
                onChange={handleChangeName}
                currentValue={textName}
                title={'お名前（最大10文字）'}
              />
              <TextInput
                type={TextInputs.TEXTAREA}
                onChange={handleChangeMenu}
                currentValue={textMenu}
                title={
                  '今日の筋トレ\n例)インチワーム10回　5セット\n腕立20回　3セット'
                }
              />
              <button
                className="bg-button drop-shadow text-white font-bold text-sm rounded-lg py-3 px-5 active:scale-105 md:text-base md:px-10"
                onClick={handleSubmit}
              >
                反映
              </button>
            </div>
          </div>
          <div className="w-95% mx-2" ref={getDivStatus}>
            {frameImage && (
              <Canvas
                bgImage={getItemFile(frameImage)}
                inputName={inputName}
                inputMenuArr={inputMenu}
                w={divWidth}
                frameImage={frameImage}
                downloadText={'報告書をDLする'}
              />
            )}
          </div>
          <div className="px-2 py-4">
            <div className="px-4 py-4 my-4 text-sm rounded-md text-left">
              <p>
                ※Twitter投稿ボタンよりツイートする場合、画像をDLの上、ご自身での添付をお願いします。
              </p>
              <p>
                ※iPhoneの場合、カメラロールではなくファイルアプリに保存されます。
              </p>
            </div>
            <a
              className="bg-twitter drop-shadow text-white font-bold text-sm rounded-lg py-3 px-5 active:scale-105 md:text-lg md:px-10"
              href="https://twitter.com/intent/tweet?hashtags=我演義,筋トレ日次報告書"
              // href="https://twitter.com/intent/tweet?hashtags=我演義,孔明と一緒に曹操軍を追い返そう！&via=wrwr_magazine"
              target="_blank"
              rel="nofollow noreferrer"
            >
              報告書をTwitter（X）で提出する
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
export default App
